// Bundled by esbuild → app/assets/builds/application.js
import "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"
import BooksIndexController from "./controllers/books_index_controller"
import BookFormController from "./controllers/book_form_controller"
import AwardsIndexController from "./controllers/awards_index_controller"
import AwardFormController from "./controllers/award_form_controller"
import AuthFormController from "./controllers/auth_form_controller"
import ToastsController from "./controllers/toasts_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("books-index", BooksIndexController)
application.register("book-form", BookFormController)
application.register("awards-index", AwardsIndexController)
application.register("award-form", AwardFormController)
application.register("auth-form", AuthFormController)
application.register("toasts", ToastsController)

// antd Modal locks page scroll while open by injecting a <style> into <head>
// (`html body { overflow-y: hidden }`, marked rc-util-key="rc-util-locker-…",
// see @rc-component/portal's useScrollLocker). If a navigation happens with the
// modal open (its Edit/Delete actions), that <style> ends up in Turbo's cached
// snapshot — so visiting/restoring the page later (e.g. after editing a book →
// /books) leaves it unscrollable. Strip any lingering locker style (and orphaned
// modal portal) around every Turbo navigation; no modal is open at that point.
const releaseScrollLock = () => {
  document
    .querySelectorAll('style[rc-util-key^="rc-util-locker"]')
    .forEach((el) => el.remove())
  document.querySelectorAll(".ant-modal-root").forEach((el) => el.remove())
}
document.addEventListener("turbo:before-cache", releaseScrollLock)
document.addEventListener("turbo:render", releaseScrollLock)
document.addEventListener("turbo:load", releaseScrollLock)


